<template>
    <div>
        <div class="widget-container">
            <DxFileUploader :accept="accept" :multiple="multiple" upload-mode="instantly"
                    :upload-url="url"
                    @uploaded="fileUploader_abortUpload($event)"
                    @option-changed="getList"
                    enctype="multipart/form-data"
                            method="post" name="file"
                    :uploadHeaders="headers"
            />
<!--            <div :style="{display: files.length > 0 ? 'block' : 'none'}" class="content">-->
<!--                <div>-->
<!--                    <div v-for="(file, index) in files" :key="index" class="selected-item">-->
<!--                        <span>文件名: {{ file.name }}<br></span>-->
<!--                        <span>文件大小 {{ file.size }}<br></span>-->
<!--                        <span>文件类型 {{ file.size }}<br></span>-->
<!--                        <span>文件修改日期: {{ file.lastModifiedDate }}</span>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
        </div>
        <div align="center" style="bottom: -300px;position:relative">&nbsp;
            <DxButton  type="danger" :use-submit-behavior="true" @click="close" text="关闭"/>
        </div>
    </div>
</template>
<script>
    import notify from "devextreme/ui/notify";
    import routerMy from "@/router";

    export default {
        data() {
            return {
                url:this.$address+"api/fun/wxuser/upload",
                multiple: false,
                accept: '*',
                headers:{token:localStorage.getItem("token")},
                res:{},
            };
        },
        methods:{
            getList(e){
              if(e.fullName=="progress" && e.value==100){
                  this.$message({type: 'success', message: '文件已上传到服务器队列，请稍后在上传记录查看进度', center: true, offset: window.screen.height / 2});
                  this.close()
              }
            },
            fileUploader_abortUpload(e) {
              this.res=JSON.parse(e.request.response)
              if(this.res.code==401 ){
                this.$message.closeAll()
                this.$message({type: 'error', message: '您最近已上传过文件请稍后再尝试', center: true, offset: window.screen.height / 2});
                this.close()
              }

            },
            close(){
                this.$emit('close');
                this.$emit('refresh');
            }
        }
    };
</script>
<style>

</style>
